(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-baseball/assets/javascripts/status.js') >= 0) return;  svs.modules.push('/components/themes/sport-baseball/assets/javascripts/status.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_baseball = svs.themes.sport_baseball || {};
  var logger = new svs.core.log.Logger('svs.themes.sport_baseball');

  svs.themes.sport_baseball.matchNotice = function (match) {
    if (!match) {
      logger.warn('Invalid parameter to matchNotice, returning empty string.');
      return '';
    }

    var matchStatus;

    switch (match.status) {
      case 16:
        matchStatus = 'Väntar på förlängning';
        break;

      case 24:
        matchStatus = 'Försenad matchstart';
        break;

      case 25:
        matchStatus = 'Inställd';
        break;

      case 26:
        matchStatus = 'Avbruten';
        break;

      case 28:
        matchStatus = 'Stoppad av domare';
        break;

      default:
        matchStatus = '';
        break;
    }

    return matchStatus;
  };

  svs.themes.sport_baseball.isLive = function (status) {
    if (window.location.href.indexOf('isMocked') > -1) {
      return true;
    }

    return !!(status > 41 && status < 62 || _.contains([13, 14, 16, 17, 19], status));
  };

  svs.themes.sport_baseball.isFinished = function (status) {
    return !!_.contains([31, 32, 41], status);
  };

  svs.themes.sport_baseball.isEnded = function (status) {
    return !!_.contains([25, 26, 28, 31, 32, 41], status);
  }; 


  svs.themes.sport_baseball.subscribeMatch = function (params) {
    return svs.themes.isDateHoursDiff(params.time, -4) && !svs.themes.sport_baseball.isEnded(params.status);
  };

  svs.themes.sport_baseball.hasStarted = function (status) {
    return status > 0 && !_.contains([23, 24, 25], status);
  };


  svs.themes.sport_baseball.isFullTimeOrPassed = function (status, options) {
    options = _.extend({
      includeFullTime: true,
      includePauses: true,
      includeFinished: true
    }, options);
    var statusesForOvertime = [19];

    if (options.includeFullTime) {
      statusesForOvertime.push(31, 41);
    }

    if (options.includePauses) {
      statusesForOvertime.push(14, 16, 17);
    }

    if (options.includeFinished) {
      statusesForOvertime.push(32);
    }

    return _.contains(statusesForOvertime, status);
  };


  svs.themes.sport_baseball.getStatusText = function (options) {
    var text = '';
    options = _.defaults({}, options, {
      statusId: null,
      startTime: null,
      getStartTime: true
    });
    var status = options.statusId;

    if (svs.themes.sport_baseball.isLive(status)) {
      if (status > 41 && status < 60) {
        text = "INN ".concat(Math.ceil((status - 41) / 2));
      } else if (_.contains([14, 16, 17], status)) {
        text = 'PAUS';
      } else if (_.contains([19, 60, 61], status)) {
        text = 'ÖT';
      }
    } else if (svs.themes.sport_baseball.isEnded(status)) {
      if (status === 26) {
        text = 'AVBR';
      } else {
        text = 'FT';
      }
    } else if (options.startTime && options.getStartTime) {
      text = svs.themes.formatTime(options.startTime);
    }

    return text;
  };
})(svs);
 })(window);